<form [formGroup]="form" style="font-family: sans-serif; font-size: 13px; padding: 16px;">

  <!-- Contact Number for Urgent Results -->
  <div style="margin-bottom: 12px;">
    <label style="display: block; font-weight: bold;">Clinician/Practitioner's Contact Number for Urgent Results</label>
    <input type="text" formControlName="urgentContactNumber_contactNumber" style="width: 100%; padding: 4px; border: 1px solid #ccc;" />
  </div>

  <!-- Insurance Type -->
  <div style="margin-bottom: 12px;">
    <strong>Insurance</strong>
    <div style="margin-top: 4px; display: flex; gap: 16px;">
      <label><input type="checkbox" formControlName="insuranceType_OHIP" /> OHIP/Insured</label>
      <label><input type="checkbox" formControlName="insuranceType_ThirdParty" /> Third Party / Uninsured</label>
      <label><input type="checkbox" formControlName="insuranceType_WSIB" /> WSIB</label>
    </div>
  </div>

  <!-- Clinical Info -->
  <div style="margin-bottom: 12px;">
    <label style="display: block; font-weight: bold;">Additional Clinical Information (e.g. diagnosis)</label>
    <input type="text" formControlName="clinicalInformation" style="width: 100%; padding: 4px; border: 1px solid #ccc;" />
  </div>

  <!-- Biochemistry -->
  <div style="margin-bottom: 12px;">
    <strong>Biochemistry</strong>
    <div style="margin-top: 4px; margin-bottom: 4px;">
      <label><input type="checkbox" formControlName="biochemistry_glucose" /> Glucose</label>
      <div style="display: flex; gap: 16px; padding-left: 20px; margin-top: 2px;">
        <label><input type="checkbox" formControlName="biochemistry_glucose_glucose_fasting" /> Fasting</label>
        <label><input type="checkbox" formControlName="biochemistry_glucose_glucose_random" /> Random</label>
      </div>
    </div>
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px;">
      <label><input type="checkbox" formControlName="biochemistry_hbA1C" /> HbA1C</label>
      <label><input type="checkbox" formControlName="biochemistry_creatinine" /> Creatinine (eGFR)</label>
      <label><input type="checkbox" formControlName="biochemistry_uricAcid" /> Uric Acid</label>
      <label><input type="checkbox" formControlName="biochemistry_sodium" /> Sodium</label>
      <label><input type="checkbox" formControlName="biochemistry_potassium" /> Potassium</label>
      <label><input type="checkbox" formControlName="biochemistry_alt" /> ALT</label>
      <label><input type="checkbox" formControlName="biochemistry_alk" /> Alk. Phosphatase</label>
      <label><input type="checkbox" formControlName="biochemistry_bilirubin" /> Bilirubin</label>
      <label><input type="checkbox" formControlName="biochemistry_albumin" /> Albumin</label>
      <label><input type="checkbox" formControlName="biochemistry_lipid" /> Lipid Assessment</label>
      <label><input type="checkbox" formControlName="biochemistry_albuminCreatinine" /> Albumin / Creatinine Ratio, Urine</label>
      <label><input type="checkbox" formControlName="biochemistry_urinalysis" /> Urinalysis (Chemical)</label>
      <label><input type="checkbox" formControlName="biochemistry_neonatal" /> Neonatal Bilirubin</label>
    </div>

    <!-- Child section -->
    <div style="margin-top: 8px; padding: 8px; border: 1px solid #ccc;">
      <label style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px;">
        <input type="checkbox" formControlName="biochemistry_child" /> Child's Age:
        <input type="text" formControlName="biochemistry_child_childAge_days" placeholder="days" style="width: 60px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        days
        <input type="text" formControlName="biochemistry_child_childAge_hours" placeholder="hours" style="width: 60px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        hours
      </label>
      <div style="display: flex; flex-direction: column; gap: 4px; padding-left: 20px;">
        <label style="display: flex; align-items: center; gap: 6px;">
          Clinician/Practitioner tel.:
          <input type="text" formControlName="biochemistry_child_clinicianTel" style="flex: 1; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        </label>
        <label style="display: flex; align-items: center; gap: 6px;">
          Patient's 24hr telephone:
          <input type="text" formControlName="biochemistry_child_patientTel" style="flex: 1; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        </label>
      </div>
    </div>

    <!-- Therapeutic Drug Monitoring -->
    <div style="margin-top: 8px; padding: 8px; border: 1px solid #ccc;">
      <label style="display: flex; align-items: center; gap: 6px; margin-bottom: 6px;">
        <input type="checkbox" formControlName="biochemistry_therapeutic" /> Therapeutic Drug Monitoring:
      </label>
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px; padding-left: 20px;">
        <label style="display: flex; flex-direction: column; gap: 2px; font-size: 11px;">
          Name of Drug #1:
          <input type="text" formControlName="biochemistry_drugs_name_1" style="border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        </label>
        <label style="display: flex; flex-direction: column; gap: 2px; font-size: 11px;">
          Name of Drug #2:
          <input type="text" formControlName="biochemistry_drugs_name_2" style="border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        </label>
        <label style="display: flex; flex-direction: column; gap: 2px; font-size: 11px;">
          Time Collected #1:
          <input type="text" formControlName="biochemistry_drugs_time_collected_1" style="border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        </label>
        <label style="display: flex; flex-direction: column; gap: 2px; font-size: 11px;">
          Time Collected #2:
          <input type="text" formControlName="biochemistry_drugs_time_collected_2" style="border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        </label>
        <label style="display: flex; flex-direction: column; gap: 2px; font-size: 11px;">
          Time of Last Dose #1:
          <input type="text" formControlName="biochemistry_drugs_lastDose_1" style="border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        </label>
        <label style="display: flex; flex-direction: column; gap: 2px; font-size: 11px;">
          Time of Last Dose #2:
          <input type="text" formControlName="biochemistry_drugs_lastDose_2" style="border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        </label>
        <label style="display: flex; flex-direction: column; gap: 2px; font-size: 11px;">
          Time of Next Dose #1:
          <input type="text" formControlName="biochemistry_drugs_nextDose_1" style="border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        </label>
        <label style="display: flex; flex-direction: column; gap: 2px; font-size: 11px;">
          Time of Next Dose #2:
          <input type="text" formControlName="biochemistry_drugs_nextDose_2" style="border: none; border-bottom: 1px solid #ccc; font-size: 12px;" />
        </label>
      </div>
    </div>
  </div>

  <!-- Hematology -->
  <div style="margin-bottom: 12px;">
    <strong>Hematology</strong>
    <div style="display: flex; gap: 16px; margin-top: 4px;">
      <label><input type="checkbox" formControlName="hematology_cbc" /> CBC</label>
      <label><input type="checkbox" formControlName="hematology_prothrombinTime" /> Prothrombin Time (INR)</label>
    </div>
  </div>

  <!-- Immunology -->
  <div style="margin-bottom: 12px;">
    <strong>Immunology</strong>
    <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-top: 4px;">
      <label><input type="checkbox" formControlName="immunology_pregnancy" /> Pregnancy Test (Urine)</label>
      <label><input type="checkbox" formControlName="immunology_mononucleosis" /> Mononucleosis Screen</label>
      <label><input type="checkbox" formControlName="immunology_rubella" /> Rubella</label>
      <label><input type="checkbox" formControlName="immunology_prenatal" /> Prenatal: ABO, RhD, Antibody Screen (titre and ident. if positive)</label>
      <label><input type="checkbox" formControlName="immunology_repeatPrenatal" /> Repeat Prenatal Antibodies</label>
    </div>
  </div>

  <!-- Microbiology -->
  <div style="margin-bottom: 12px;">
    <strong>Microbiology ID &amp; Sensitivities</strong>
    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px; margin-top: 4px;">
      <label><input type="checkbox" formControlName="microbiology_cervical" /> Cervical</label>
      <label><input type="checkbox" formControlName="microbiology_vaginal" /> Vaginal</label>
      <label><input type="checkbox" formControlName="microbiology_vaginalRectal" /> Vaginal / Rectal - Group B Strep</label>
      <label style="display: flex; align-items: center; gap: 4px;">
        <input type="checkbox" formControlName="microbiology_chlamydia" /> Chlamydia
        <input type="text" formControlName="microbiology_chlamydia_desc" placeholder="specify source" style="border: none; border-bottom: 1px solid #ccc; font-size: 11px; width: 90px;" />
      </label>
      <label style="display: flex; align-items: center; gap: 4px;">
        <input type="checkbox" formControlName="microbiology_GC" /> GC
        <input type="text" formControlName="microbiology_GC_desc" placeholder="specify source" style="border: none; border-bottom: 1px solid #ccc; font-size: 11px; width: 90px;" />
      </label>
      <label><input type="checkbox" formControlName="microbiology_sputum" /> Sputum</label>
      <label><input type="checkbox" formControlName="microbiology_throat" /> Throat</label>
      <label style="display: flex; align-items: center; gap: 4px;">
        <input type="checkbox" formControlName="microbiology_wound" /> Wound
        <input type="text" formControlName="microbiology_wound_desc" placeholder="specify source" style="border: none; border-bottom: 1px solid #ccc; font-size: 11px; width: 90px;" />
      </label>
      <label><input type="checkbox" formControlName="microbiology_urine" /> Urine</label>
      <label><input type="checkbox" formControlName="microbiology_stoolCulture" /> Stool Culture</label>
      <label><input type="checkbox" formControlName="microbiology_stoolOva" /> Stool Ova &amp; Parasites</label>
      <label style="display: flex; align-items: center; gap: 4px;">
        <input type="checkbox" formControlName="microbiology_otherSwabs" /> Other Swabs / Pus
        <input type="text" formControlName="microbiology_otherSwabs_desc" placeholder="specify source" style="border: none; border-bottom: 1px solid #ccc; font-size: 11px; width: 90px;" />
      </label>
    </div>
  </div>

  <!-- Specimen Collection -->
  <div style="margin-bottom: 12px;">
    <strong>Specimen Collection</strong>
    <div style="display: flex; gap: 24px; margin-top: 4px;">
      <label style="display: flex; align-items: center; gap: 6px;">
        Time: <input type="text" formControlName="specimenCollectionTime" placeholder="24 hour clock" style="border: 1px solid #ccc; padding: 2px 4px; font-size: 12px; width: 100px;" />
      </label>
      <label style="display: flex; align-items: center; gap: 6px;">
        Date: <input type="text" formControlName="specimenCollectionDate" placeholder="yyyy/mm/dd" style="border: 1px solid #ccc; padding: 2px 4px; font-size: 12px; width: 100px;" />
      </label>
    </div>
  </div>

  <!-- Viral Hepatitis -->
  <div style="margin-bottom: 12px;">
    <strong>Viral Hepatitis (check one only)</strong>
    <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-top: 4px;">
      <label><input type="checkbox" formControlName="viralHepatitis_acute" /> Acute Hepatitis</label>
      <label><input type="checkbox" formControlName="viralHepatitis_chronic" /> Chronic Hepatitis</label>
      <label><input type="checkbox" formControlName="viralHepatitis_immuneStatus" /> Immune Status / Previous Exposure</label>
      <label style="padding-left: 16px;"><input type="checkbox" formControlName="viralHepatitis_immuneStatus_hepatitisA" /> Hepatitis A</label>
      <label><input type="checkbox" formControlName="viralHepatitis_immuneStatus_hepatitisB" /> Hepatitis B</label>
      <label><input type="checkbox" formControlName="viralHepatitis_immuneStatus_hepatitisC" /> Hepatitis C</label>
    </div>
  </div>

  <!-- PSA -->
  <div style="margin-bottom: 12px;">
    <strong>Prostate Specific Antigen (PSA)</strong>
    <div style="display: flex; gap: 16px; margin-top: 4px;">
      <label><input type="checkbox" formControlName="psa_totalPSA" /> Total PSA</label>
      <label><input type="checkbox" formControlName="psa_freePSA" /> Free PSA</label>
      <label><input type="checkbox" formControlName="psa_insured" /> Insured (OHIP)</label>
      <label><input type="checkbox" formControlName="psa_uninsured" /> Uninsured (Screening)</label>
    </div>
  </div>

  <!-- Vitamin D -->
  <div style="margin-bottom: 12px;">
    <strong>Vitamin D (25-Hydroxy)</strong>
    <div style="display: flex; gap: 16px; margin-top: 4px;">
      <label><input type="checkbox" formControlName="vitaminD_insured" /> Insured (OHIP)</label>
      <label><input type="checkbox" formControlName="vitaminD_uninsured" /> Uninsured</label>
    </div>
  </div>

  <!-- Other Tests -->
  <div style="margin-bottom: 12px;">
    <strong>Other Tests</strong>
    <div formGroupName="otherTests_test" style="display: grid; grid-template-columns: 1fr 1fr; gap: 4px; margin-top: 4px;">
      <input type="text" formControlName="t1"  style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t2"  style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t3"  style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t4"  style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t5"  style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t6"  style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t7"  style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t8"  style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t9"  style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t10" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t11" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t12" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t13" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t14" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t15" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t16" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t17" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t18" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t19" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t20" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t21" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t22" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t23" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t24" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t25" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t26" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t27" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t28" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t29" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
      <input type="text" formControlName="t30" style="padding: 2px 4px; border: none; border-bottom: 1px solid #ccc; font-size: 12px;" placeholder="Test" />
    </div>
  </div>

  <ng-container *ngIf="templateVariant === 'lgv_paid'">
    <div style="margin-top: 20px; border: 1px solid #000; font-family: Calibri, Arial, sans-serif; font-size: 13px;">

      <!-- Page 2 header -->
      <div style="background: #99CBFD; padding: 10px 14px; font-weight: bold; font-size: 17px; border-bottom: 1px solid #000; -webkit-print-color-adjust: exact; print-color-adjust: exact;">
        LifeLabs Contract — Page 2 (AX613)
      </div>

      <!-- Client Reference row -->
      <div style="display: grid; grid-template-columns: 160px 1fr; border-bottom: 1px solid #000;">
        <div style="padding: 5px 14px; font-size: 12px; font-weight: bold; border-right: 1px solid #000; background: #f5f5f5;">Client Reference:</div>
        <div style="padding: 5px 14px;">
          <input formControlName="lgvPaid_clientReference" type="text" placeholder="Optional" style="width: 100%; border: none; border-bottom: 1px solid #aaa; font-size: 12px; background: transparent;" />
        </div>
      </div>

      <!-- Ordering Doctor row -->
      <div style="display: grid; grid-template-columns: 160px 1fr; border-bottom: 1px solid #000;">
        <div style="padding: 5px 14px; font-size: 12px; font-weight: bold; border-right: 1px solid #000; background: #f5f5f5;">Ordering Doctor:</div>
        <div style="padding: 5px 14px; display: flex; align-items: center; gap: 6px;">
          <input formControlName="lgvPaid_danTalya" type="checkbox" style="cursor: pointer;" />
          <span>Dan Talya, NP</span>
        </div>
      </div>

      <!-- Tests Requested header -->
      <div style="background: #99CBFD; text-align: center; font-weight: bold; font-size: 14px; padding: 4px 8px; border-bottom: 1px solid #000; -webkit-print-color-adjust: exact; print-color-adjust: exact;">
        TESTS REQUESTED
      </div>

      <!-- Test checkboxes -->
      <div style="padding: 10px 18px; display: flex; flex-direction: column; gap: 8px; font-size: 13px;">
        <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
          <input formControlName="lgvPaid_docFee" type="checkbox" />
          <strong>Documentation Fee (code 105)</strong>
        </label>
        <label *ngIf="customerGender?.toLowerCase() !== 'female' && customerGender?.toLowerCase() !== 'f'" style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
          <input formControlName="lgvPaid_psa" type="checkbox" />
          PSA (code 10P)
        </label>
        <label *ngIf="!customerGender || customerGender === 'male' || customerGender === 'm'" style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
          <input formControlName="lgvPaid_shbg" type="checkbox" />
          SHBG (code 2019)
        </label>
        <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
          <input formControlName="lgvPaid_vitaminD25" type="checkbox" />
          Vitamin D 25 OH (code 99V)
        </label>
      </div>

    </div>
  </ng-container>

</form>
